import React, { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { Grid, Segment, Header } from "semantic-ui-react";
import { ConnectedLoginForm } from "./ConnectedLoginForm";
import { ConnectedRegisterForm } from "./ConnectedRegisterForm";

const LinkButton = styled.a`
  &&& {
    color: #4183c4;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const LoginRegisterCard = () => {
  const { site } = useParams<{ site: string }>();
  const [mode, setMode] = useState<string>("login");
  const isLoginMode = mode === "login";
  const isRegisterMode = mode === "register";

  return (
    <div className='tw-flex tw-justify-center'>
      <Segment basic className='tw-w-[500px]'>
        <Segment padded attached='top'>
          <Header>{isLoginMode ? `Sign In to Continue` : `Create Account to Continue`}</Header>
        </Segment>
        <Segment attached padded>
          <Grid style={{ margin: 0, height: "100%" }} verticalAlign='middle' textAlign='center'>
            <Grid.Column style={{ maxWidth: "450px", textAlign: "left" }}>
              {isLoginMode && <ConnectedLoginForm site={site} usernameLabel='Email Address' allowRememberMe={true} />}
              {isRegisterMode && <ConnectedRegisterForm site={site} />}
            </Grid.Column>
          </Grid>
        </Segment>
        <Segment attached='bottom' padded center textAlign='center'>
          {isLoginMode && (
            <>
              {`New user? `}
              <LinkButton
                href='#'
                style={{ fontWeight: "bold" }}
                onClick={() => setMode(isLoginMode ? "register" : "login")}
              >
                Create an account here
              </LinkButton>
            </>
          )}
          {isRegisterMode && (
            <>
              {`Already have an account? `}
              <LinkButton
                href='#'
                style={{ fontWeight: "bold" }}
                onClick={() => setMode(isLoginMode ? "register" : "login")}
              >
                Sign in here
              </LinkButton>
            </>
          )}
        </Segment>
      </Segment>
    </div>
  );
};

export default LoginRegisterCard;
